import { Asterisk } from "lucide-react";
import { useSiteContent } from "@/content/ContentContext.jsx";

const Marquee = () => {
  const { content } = useSiteContent();
  const items = content.marquee?.items?.length
    ? content.marquee.items.map((i) => (typeof i === "string" ? i : i.text)).filter(Boolean)
    : ["Angukumaran Farmhouse"];

  const row = (ariaHidden) => (
    <div className="flex shrink-0 items-center" aria-hidden={ariaHidden}>
      {items.map((item) => (
        <span key={item + (ariaHidden ? "-b" : "-a")} className="flex items-center">
          <span className="whitespace-nowrap px-8 font-display text-xl italic tracking-wide text-brand sm:text-2xl">
            {item}
          </span>
          <Asterisk size={22} className="shrink-0 text-brand-light" />
        </span>
      ))}
    </div>
  );

  return (
    <div className="overflow-hidden border-y hairline bg-brand-tint/60 py-6" data-testid="marquee-band">
      <div className="flex w-max animate-marquee hover:[animation-play-state:paused]">
        {row(false)}
        {row(true)}
      </div>
    </div>
  );
};

export default Marquee;
